import { PERSIAN_THEME } from '../../../theme/persianTheme';

/**
 * Get player color based on position and total player count.
 * 4P: Team colors (Gold for South+North, Teal for West+East)
 * 2P/3P: Individual colors
 */
export function getPlayerColor(position: number, playerCount: number): number {
  if (playerCount === 4) {
    // Team mode: South+North = Gold, West+East = Teal
    return position === 0 || position === 2 ? PERSIAN_THEME.colors.teamA : PERSIAN_THEME.colors.teamB;
  } else {
    // Individual colors for 2P/3P
    const colors = [
      PERSIAN_THEME.colors.player1, // Position 0 - Teal
      PERSIAN_THEME.colors.player2, // Position 1 - Coral
      PERSIAN_THEME.colors.player3, // Position 2 - Purple
      PERSIAN_THEME.colors.player1, // Position 3 (fallback)
    ];
    return colors[position];
  }
}
